import {useContext} from 'react'
import {FloatingContext} from './floating_context'

export const useFloatingContext = () => useContext(FloatingContext)
